import axios from "axios";

export default {

    namespaced: true,

    state: {

        loansecurities: [],
        loansecurity: {},
        loanSecuritiesByLoanApplicationId: [],

    },

    getters: {

        loansecurities(state) {
            return state.loansecurities;
        },
        loansecurity(state) {
            return state.loansecurity;
        },
        loanSecuritiesByLoanApplicationId(state) {
            return state.loanSecuritiesByLoanApplicationId;
        }

    },

    mutations: {

        SET_LOAN_SECURITIES(state, loansecurities) {
            return state.loansecurities = loansecurities
        },

        SET_LOAN_SECURITY(state, loansecurity) {
            return state.loansecurity = loansecurity
        },

        SET_LOAN_SECURITIES_BY_LOAN_APPLICATION_ID(state, loanSecuritiesByLoanApplicationId) {
            return state.loanSecuritiesByLoanApplicationId = loanSecuritiesByLoanApplicationId
        }

    },

    actions: {

        async fetchloansecurities({ commit }, params) {

            await axios.get('/api/v1/loan-securities', { params: params })
                .then(res => {
                    commit('SET_LOAN_SECURITIES', res.data);
                }).catch(err => {
                    return Promise.reject(err);
                })

        },

        async fetchloansecurity({ commit }, loan_security_id) {

            await axios.get(`/api/v1/loan-securities/${loan_security_id}`)
                .then(res => {
                   commit('SET_LOAN_SECURITY', res.data.data);
                }).catch(err => {
                    return Promise.reject(err);
                })
        },

        async fetchloansecuritybyloanapplicationid({ commit }, loan_application_id) {
            await axios.get(`/api/v1/loan-securities/loan-application/${loan_application_id}`)
                .then(res => {
                    commit('SET_LOAN_SECURITIES_BY_LOAN_APPLICATION_ID', res.data.data);
                }).catch(err => {
                    return Promise.reject(err);
                })
        },

        async createloansecurity({ commit, dispatch }, loansecurity) {
            await axios.post('/api/v1/loan-securities', loansecurity)
                .then(res => {
          
                }).catch(err => {
                    return Promise.reject(err);
                })

        },

        async updateloansecurity({ commit, dispatch },{id,data}) {

            await axios.put(`/api/v1/loan-securities/${id}`, data).then(res => {
          
            }).catch(err => {
                return Promise.reject(err);
            })

        },

        async deleteloansecurity({ commit }, loan_security_id) {

            await axios.delete(`/api/v1/loan-securities/${loan_security_id}`)
                .then(res => {
                }).catch(err => {
                    return Promise.reject(err);
                });

        }

    }

}
